import React from "react";
import { Button, Icon } from "react-materialize";
import FormFunc from "../../../utils/FormFunc";
import { useInfo } from "context/InfoContext";

const getLengthOfService = (startDate, endDate) => {
  // Length of service
  if (startDate != null) {
    let one_day = 1000 * 60 * 60 * 24;
    startDate = new Date(startDate);
    const now = new Date();
    const effectiveEndDate = endDate ? new Date(endDate) : now;
    const boundedEndDate =
      endDate && now < effectiveEndDate ? now : effectiveEndDate;
    if (startDate > boundedEndDate) {
      return "";
    }
    const result = Math.round(
      (boundedEndDate.getTime() - startDate.getTime()) / one_day,
    );
    const years = Math.floor(result / 365);
    const months = Math.floor((result - years * 365) / 30);
    const days = result - years * 365 - months * 30;
    const temps = [];
    if (years > 0) {
      temps.push(years + " year" + (years > 1 ? "s" : ""));
    }
    if (months > 0) {
      temps.push(months + " month" + (months > 1 ? "s" : ""));
    }
    if (years === 0 && months === 0 && days > 0) {
      temps.push(days + " day" + (days > 1 ? "s" : ""));
    }
    let text = temps.join(" ");
    return text;
  }
  return "";
};

export default function EmpProbationContent({
  boxName,
  userData,
  handleEvents,
}) {
  const { infos, filters } = useInfo();
  let addClass = "col s4";
  const isCannotEdit =
    userData?.user_sess?.userCanAccessHrAssign || userData?.user_sess?.isAdmin
      ? false
      : true;
  return (
    <div
      key={"probation-content-" + boxName + "-" + filters.key_form}
      style={{ marginTop: "25px" }}
    >
      <div className={boxName + " row"}>
        {infos?.staff_id ? (
          <FormFunc.InputText
            data={{
              name: "length_service",
              label: "Length of service",
              addClass: addClass,
              defaultValue: getLengthOfService(
                filters?.start_date,
                filters?.active === "N" ? filters?.end_date : null,
              ),
              disabled: true,
            }}
            events={handleEvents}
          />
        ) : (
          ""
        )}
        <FormFunc.InputText
          data={{
            name: "probation_days",
            label: "Probation Days",
            addClass: addClass,
            defaultValue: filters?.["probation_days"] ?? "",
            disabled: isCannotEdit,
          }}
          events={handleEvents}
        />
        <FormFunc.SingleSelect
          data={{
            name: "active",
            label: (
              <div>
                Active Status*
                {/* <a
                  className="textcolor-green"
                  href="/"
                  style={{ marginLeft: "10px", textDecoration: "underline" }}
                >
                  Send notification?
                </a> */}
              </div>
            ),
            options: [
              { name: "YES", value: "Y" },
              { name: "NO", value: "N" },
            ],
            addClass: addClass,
            optionName: "name",
            optionValue: "value",
            optionTitle: "---",
            defaultValue: filters?.["active"] ?? "N",
            disabled: isCannotEdit,
            required: true,
          }}
          events={handleEvents}
        />
      </div>
      <div className={boxName + " row"} style={{ paddingBottom: "20px" }}>
        <i
          className="small material-icons textcolor-green"
          style={{ fontSize: "13px", float: "left", marginLeft: "10px" }}
        >
          info
        </i>
        <span style={{ fontSize: "10px", marginLeft: "5px", float: "left" }}>
          The reminder will be sent to the approver when the probation period to
          completed.
        </span>
      </div>
    </div>
  );
}
